import type { FilterInput } from '../constants';
import type { AnimalSearchFieldLookup } from './constants';
import { parseI6LookupString } from './parseI6LookupString';

export type ExpandedI6LookupFilters = {
  filters: FilterInput[];
  orGroups: FilterInput[][];
};

/**
 * Replace `__lookup__<field>` marker rows with filters parsed from the
 * selected lookup's `i6LookupString`. Multi-value OR lookups become
 * `orGroups` entries for nested GraphQL filter groups.
 */
export function expandI6LookupMarkerFilters(
  filters: FilterInput[],
  resolver: Map<string, AnimalSearchFieldLookup[]>,
  prefix: string,
): ExpandedI6LookupFilters {
  const expanded: FilterInput[] = [];
  const orGroups: FilterInput[][] = [];

  for (const f of filters) {
    if (!f.field?.startsWith(prefix)) {
      expanded.push(f);
      continue;
    }
    if (!f.value) continue;

    const lookups = resolver.get(f.field);
    if (!lookups) continue;

    const choice = lookups.find((l) => l.code === f.value);
    if (!choice?.i6LookupString) continue;

    const parsed = parseI6LookupString(choice.i6LookupString);
    if (parsed.filters.length === 0) continue;

    if (parsed.logicalOperator === 'Or' && parsed.filters.length > 1) {
      orGroups.push(parsed.filters);
    } else {
      expanded.push(...parsed.filters);
    }
  }

  return { filters: expanded, orGroups };
}
